import React, {useEffect, useState} from 'react';
import styles from "./dropdown.module.css";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {getLessons, getStoryLessons} from "../../../../api/requests";
import useTranslation from "next-translate/useTranslation";

const DropdownGetBooks = ({classes, defaultSelected, setSelectedTopic,data,setLessons,setGrade,setSelectedLesson,setLessonWords,setError,setShow,setShow2}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => {
        const Username = localStorage.getItem('Username');
        const token = localStorage.getItem('token');
        if (Username && token) {
            setDropdownOpen(prevState => !prevState)
        } else {
            setError(["login", false])
            setShow(true)
        }
    };
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';

    const [selectedBook, setSelectedBook] = useState({LessonId:null,name:null});

    useEffect(() => {
        setSelectedBook({LessonId:null,name:isRTL ? defaultSelected.fa : defaultSelected.en})
    }, [isRTL])

    const handleSelect = (selectedItem) => {
        setSelectedTopic(null)
        setSelectedBook({LessonId:selectedItem.item.GroupCodeId,name:selectedItem.item.AbvName})
        setGrade({code:selectedItem.item.GroupCodeId,name:selectedItem.item.AbvName})
        setSelectedLesson({LessonId:null,name:isRTL ?'درس خود را انتخاب کنید':'Choose Your Lesson'})
        setLessonWords(null)
        // setValidated(prevState => ({...prevState, book: true}))
        const token = localStorage.getItem('token')
        getStoryLessons( selectedItem.item.GroupCodeId,token).then(res => {
            // console.log("story writing lessons res:",res.data)
            if (Array.isArray(res.data)) {
                setLessons(res.data)
            } else {
                console.log(res.data)
            }
            // setLoading(false)
        }).catch(err => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.setItem('token', '');
                localStorage.setItem('Username', '');
                localStorage.setItem('Counter', '');
                localStorage.setItem('isLogin', '');
                localStorage.setItem('CellPhoneNum', '');
                setShow2(true);
            }
            else {
                console.log("getStoryLessons error:", {err})
            }
        })
    };

    return (
        <div className={styles.wrapper}>
            <div>
                <Dropdown className={`${styles.menuItem} ${classes.bg}`} isOpen={dropdownOpen} toggle={toggle}>
                    <div className={classes.arrow}/>
                    <DropdownToggle caret>
                        {selectedBook && selectedBook.name}
                    </DropdownToggle>
                    <DropdownMenu>
                        {data && data.length > 0 ? data.map((item, index) => {
                            return <DropdownItem key={index} onClick={() => handleSelect({
                                item: item,
                                id: index + 1
                            })}>{isRTL ? item.PersianName : item.AbvName}</DropdownItem>
                        }) : <DropdownItem>Loading...</DropdownItem>}
                    </DropdownMenu>
                </Dropdown>
            </div>

        </div>

    );
};

export default DropdownGetBooks;